import React, {FC, ReactNode} from 'react';
import {Outlet} from 'react-router-dom';
import background from '../../assets/background.png';
import {Grid, styled} from '@mui/material';
import {LogoHeader} from "../../components/LogoHeader/LogoHeader";

const PageContainer = styled(Grid)(({ theme }) => ({
    ...theme.typography.body2,
    height: '100vh',
    backgroundImage: `url(${background})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    boxShadow: 'inset 0 0 0 1000px rgba(0,0,0,.4)',
}));

const LeftPart = styled(Grid)({
    backgroundColor: '#ffffff',
    padding: '1vh 2vw 2vh 2vw',
    height: '100%',
    overflow: 'auto',
});

const ContentRow = styled(Grid)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    height: '86vh',
    padding: '1vh 2vw',
    minHeight: 'fit-parent',
    maxHeight: '200vh',
}));

interface VisitorLayoutProps {
    children?: ReactNode;
}
const VisitorLayout: FC<VisitorLayoutProps> = ({ children }) => {
    return (
        <PageContainer container>
            <LeftPart item md={10} width="100%">
                <LogoHeader />
                <ContentRow container>
                    <Grid item xs={12} xl={10}>
                        {children || <Outlet />}
                    </Grid>
                </ContentRow>
            </LeftPart>
        </PageContainer>
    );
};

export default VisitorLayout;
